var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep7Off(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3523_9986)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FDFDFD",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2029 35.7701L24.2454 31.9152L25.585 30.6103L28.2029 33.1603L33.415 28.0835L34.7546 29.3884L28.2029 35.7701ZM21.2331 40C20.6091 40 20.0809 39.7894 19.6485 39.3683C19.2162 38.9472 19 38.4327 19 37.8249V21.7203C19 21.1124 19.2162 20.598 19.6485 20.1768C20.0809 19.7557 20.6091 19.5451 21.2331 19.5451H22.9434V17H24.8439V19.5451H34.2037V17H36.0566V19.5451H37.7669C38.3909 19.5451 38.9191 19.7557 39.3515 20.1768C39.7838 20.598 40 21.1124 40 21.7203V37.8249C40 38.4327 39.7838 38.9472 39.3515 39.3683C38.9191 39.7894 38.3909 40 37.7669 40H21.2331ZM21.2331 38.1952H37.7669C37.862 38.1952 37.9491 38.1566 38.0282 38.0793C38.1074 38.0023 38.1471 37.9175 38.1471 37.8249V26.5332H20.8529V37.8249C20.8529 37.9175 20.8926 38.0023 20.9718 38.0793C21.0509 38.1566 21.138 38.1952 21.2331 38.1952Z",
    fill: "#D1D5D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3523_9986",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.819608 0 0 0 0 0.835294 0 0 0 0 0.847059 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3523_9986"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3523_9986",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep7Off);
export default __webpack_public_path__ + "static/media/step7-off.ac2de7b7fe360d21575d076c6c220c05.svg";
export { ForwardRef as ReactComponent };